import * as React from "react";
import CustomField from "../../../../../model/customField/CustomField";
import EditCustomFieldFormView from "./EditCustomFieldFormView";

interface IComponentProps {
	/**
	 * On cancel button click.
	 */
	onCancel: () => void;
	/**
	 * Custom field to edit.
	 */
	customField: CustomField;
	/**
	 * Update custom field.
	 * @param {CustomField} customField
	 * @param {void} onActionFinish
	 */
	updateCustomField: (customField: CustomField, onActionFinish: () => void) => void;
}

interface IState {
	/**
	 * Indicate if any server action is in progress.
	 */
	isSubmitting: boolean;
}

export default class EditCustomFieldForm extends React.PureComponent<IComponentProps, IState> {
	constructor(props: IComponentProps) {
		super(props);
		this.state = {isSubmitting: false};
		this.onSubmit = this.onSubmit.bind(this);
		this.onSubmitFinish = this.onSubmitFinish.bind(this);
	}

	render() {
		return (
			<EditCustomFieldFormView onSubmit={this.onSubmit}
									 onCancel={this.props.onCancel}
									 isSubmitting={this.state.isSubmitting}
									 customField={this.props.customField}/>
		);
	}

	onSubmit(editedCustomField: CustomField) {
		this.setState({isSubmitting: true}, () => {
			const customField = editedCustomField.copy({id: this.props.customField.id});
			this.props.updateCustomField(customField, this.onSubmitFinish);
		});
	}

	onSubmitFinish() {
		this.setState({isSubmitting: false});
	}
}